module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContainer"
  }, [_c('div', {
    staticClass: "summaryContainer"
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('h1', {
    staticClass: "summary-header"
  }, [_c('div', {
    staticClass: "summary-symbol"
  }, [_vm._v("\r\n          " + _vm._s(_vm.note.title) + "\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "summary-toolbar"
  }, [_c('router-link', {
    staticClass: "summary-edit",
    attrs: {
      "to": '/note/' + _vm.$route.params.name + '/edit'
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("edit")]), _vm._v("\r\n            Edit\r\n          ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "stock-text markdown-text",
    domProps: {
      "innerHTML": _vm._s(this.body)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c99cd106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/noteview.vue
// module id = 76
// module chunks = 0